import { memo } from "react";

const index = ({}) => {
  return (
    <div className="col-12">
      <div className="alert alert-warning">
        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> No
        records found.
      </div>
    </div>
  );
};

export default memo(index);
